import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import milwaukee__asset from "@/assets/restore/locations/milwaukee.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Milwaukee",
    address: "250 East Wisconsin Avenue, Suite 1800",
    img: milwaukee__asset.url,
    mapUrl: map("250 East Wisconsin Avenue Milwaukee WI"),
    to: "/locations/wisconsin/milwaukee/",
  },
];

export const Route = createFileRoute("/locations/wisconsin/")({
  head: () => ({
    meta: [
      { title: "Wisconsin Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Wisconsin. Book a free personal hair loss consultation at our Milwaukee location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Wisconsin Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Milwaukee, Wisconsin and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/wisconsin/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/wisconsin/" }],
  }),
  component: () => <StateLocationsHub stateName="Wisconsin" cities={cities} />,
});